import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-send-delivery-mail-dialog',
  templateUrl: './send-delivery-mail-dialog.component.html',
  styleUrls: ['./send-delivery-mail-dialog.component.scss']
})
export class SendDeliveryMailDialogComponent implements OnInit {
  @Input() data: string;

  constructor(
    private modal: NgbActiveModal) { }

  ngOnInit(): void {
    console.log(this.data);
  }

  close(result: string = null) {
    this.modal.close(result);
  }

  async onSubmit() {
    try {
      this.close(this.data);
    } catch (err) {
      console.error("Sertifika gönderilirken hata oluştu:", err);
    }
  }

}
